



































































































































































































import { computed, defineComponent, PropType } from '@vue/composition-api';

import {
  WorkflowFormFieldTypeEnum,
  IWorkflowFormFieldData,
  IWorkflowFormSectionFieldData,
  IWorkflowFormField
} from '@/models';

import DatePicker from '../common/DatePicker.vue';
import DragDropFileInput from '../common/DragDropFileInput.vue';

export default defineComponent({
  name: 'WorkflowFormBuilderField',
  components: { DatePicker, DragDropFileInput },
  props: {
    section_field: {
      type: Object as PropType<IWorkflowFormSectionFieldData>,
      required: true
    }
  },
  setup(props, context) {
    const fieldTemplate = computed<IWorkflowFormField>(
      () => props.section_field.field_template as IWorkflowFormField
    );

    function genLabel(section_field: IWorkflowFormSectionFieldData) {
      let label = (section_field.field_template as IWorkflowFormFieldData)
        .label;
      if (section_field.required) label = `${label}*`;
      return label;
    }

    return { WorkflowFormFieldTypeEnum, genLabel, fieldTemplate };
  }
});
